import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Spin } from "antd";
import { Creatable } from "./creatable.js";
import { useFolderTree } from "../contexts/folderTree.js";
import { useFolderTreeRuntime } from "../contexts/folderTreeRuntime.js";
import { useTreeInteraction } from "../contexts/treeInteraction.js";
import { getRecursivelyCheckedNodes } from "../util/tree.js";
import { Toolbar } from "./toolbar/toolbar.js";
/**
 * Render the header with headline, buttons and toolbar. In this part the sticky component
 * is ensured and you do not have to worry about it.
 */ const Header = ()=>{
    const { headline, creatable, toolbar, multiToolbar, isCreatableLinkDisabled: configCreatableLinkDisabled, isCreatableLinkCancel, isToolbarActive: configToolbarActive, isToolbarBusy, toolbarActiveButton, isBusyHeader, isSortableBusy, tree } = useFolderTree();
    const { handleCreatableHeaderClick } = useFolderTreeRuntime();
    const { searchTerm, handleCloseMultiToolbar } = useTreeInteraction();
    const wireCreatableClick = (type, buttonProps)=>({
            ...buttonProps,
            onClick: (clickedType)=>{
                const resolvedType = clickedType ?? type;
                if (handleCreatableHeaderClick) {
                    handleCreatableHeaderClick(resolvedType, buttonProps.onClick);
                    return;
                }
                buttonProps.onClick?.(resolvedType);
            }
        });
    const checkedNodes = getRecursivelyCheckedNodes(tree);
    const effectiveSortingBusy = isSortableBusy;
    const isCreatableLinkDisabled = searchTerm || effectiveSortingBusy || checkedNodes.length ? true : configCreatableLinkDisabled;
    const isToolbarActive = effectiveSortingBusy ? false : configToolbarActive;
    const useToolbar = checkedNodes.length ? multiToolbar : toolbar;
    return /*#__PURE__*/ _jsxs(Spin, {
        spinning: !!isBusyHeader,
        size: "small",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "aiot-tree-headline",
                children: [
                    headline,
                    !isCreatableLinkCancel ? Object.keys(creatable.buttons).map((key)=>/*#__PURE__*/ _jsx(Creatable, {
                            type: key,
                            ...wireCreatableClick(key, creatable.buttons[key]),
                            isCreatableLinkDisabled: isCreatableLinkDisabled
                        }, key)) : /*#__PURE__*/ _jsx(Creatable, {
                        ...wireCreatableClick("_aio_cancel", creatable.backButton),
                        type: "_aio_cancel"
                    })
                ]
            }),
            (!!Object.keys(useToolbar.buttons).length || checkedNodes.length > 0) && /*#__PURE__*/ _jsx(Toolbar, {
                isToolbarActive: isToolbarActive,
                isToolbarBusy: isToolbarBusy,
                buttons: useToolbar.buttons,
                backButton: useToolbar.backButton,
                activeButton: toolbarActiveButton,
                checkedNodes: checkedNodes,
                onCloseMultiToolbar: handleCloseMultiToolbar
            })
        ]
    });
};
export { Header };
